import Cart from './Cart';
import Shop from './Shop';

class Entities {
    constructor() {
        /** @type {src/entities/Cart.js~Cart} */
        this.Cart = Cart;
        /** @type {src/entities/Shop.js~Shop} */
        this.Shop = Shop;
    }
}

/** @ignore */
export default new Entities;



// WEBPACK FOOTER //
// ./src/entities/index.js